import { useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { LinkButton, PrimaryButton } from 'Components/_theme'

import { HubspotQuestionModal } from 'Modals/HubspotQuestionModal/HubspotQuestionModal'

import { openIntercomChat } from 'Utilities'

import { E2E_LINK_HUBSPOT_CONTACT } from 'Constants/e2e'

import { useModal } from 'Portal/src/hooks'

import { OrderIntercomButtonProps } from './OrderIntercomButton.types'

export const OrderIntercomButton = (props: OrderIntercomButtonProps) => {
  const { caseItemId } = props
  const intl = useIntl()
  const { setModal } = useModal()

  const handleOpenChatButtonClick = useCallback(() => {
    const intercomMessage = intl.formatMessage(
      {
        id: 'PreviewColumn_intercom_intro',
      },
      {
        id: caseItemId,
        type: intl.formatMessage({
          id: 'PreviewColumn_type_request',
        }),
      },
    )

    openIntercomChat(intercomMessage)
  }, [caseItemId, intl])

  const handleOpenHubspotQuestionModal = useCallback(() => {
    setModal({
      component: HubspotQuestionModal,
      isOpen: true,
      props: {},
    })
  }, [setModal])

  return (
    <>
      <div className="d-flex justify-content-end align-items-center w-100 mb-1">
        <p className="mb-0">
          <FormattedMessage id="OrderIntercomButton_Have_a_question" />
        </p>

        <PrimaryButton
          className="ms-2"
          onClick={handleOpenChatButtonClick}
          size="small"
        >
          <FormattedMessage id="OrderIntercomButton_Open_chat" />
        </PrimaryButton>
      </div>

      <div className="d-flex justify-content-end text-muted">
        <small className="text-end">
          <FormattedMessage id="OrderIntercomButton_Subtitle" />{' '}
          <LinkButton
            className="OrderIntercomButton-contact-form-button"
            data-e2e={E2E_LINK_HUBSPOT_CONTACT}
            onClick={handleOpenHubspotQuestionModal}
          >
            <FormattedMessage id="OrderIntercomButton_Contact_form" />
          </LinkButton>
        </small>
      </div>
    </>
  )
}
